import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

import * as GroupActions from '../actions/group.actions';
import { GroupService } from '../../service/group.service';

@Injectable()
export class GroupEffects {

    constructor(
        private actions$: Actions,
        private groupService: GroupService
    ) {}

    loadGroups$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GroupActions.LoadGroups),
            switchMap(() => {
                const params = new HttpParams();
                
                return this.groupService.getGroups(params).pipe(
                    map(response => {
                        const groups = response.results || [];
                        this.groupService.appGroups.next(groups); // Sync avec BehaviorSubject pour compatibilité
                        return GroupActions.LoadGroupsSuccess({ groups });
                    }),
                    catchError(error => {
                        return of(GroupActions.LoadGroupsFailure({ error: error.message }));
                    })
                );
            })
        )
    );
}
